import React, { memo } from "react";

const YEAR = new Date().getFullYear();

const Footer = () => (
  <div className="footerpart">
    <p>
      © {YEAR} Shalimar Hosiery,
      <span>Designed by{" "}
        <a href="https://www.thegraphe.com" target="_blank" rel="noopener noreferrer">
          The Graphe - A Design Studio
        </a>
      </span>
    </p>
  </div>
);

export default memo(Footer);
